(function () {
  'use strict';

  function initTwwSearch() {
    if (!window.customElements || !customElements.get('predictive-search')) return;

    var PredictiveSearch = customElements.get('predictive-search');

    if (!PredictiveSearch.prototype.twwSearchRedesignInstalled) {
      PredictiveSearch.prototype.twwSearchRedesignInstalled = true;

      PredictiveSearch.prototype.getSearchResults = function (searchTerm) {
        var scope = this.querySelector('[data-search-scope]');
        var selectedScope = scope ? scope.value : 'all';
        var resourceTypes = 'product,collection,query,page,article';

        if (selectedScope === 'products') resourceTypes = 'product,query';
        if (selectedScope === 'categories') resourceTypes = 'collection,query';

        this.dataset.searchScopeCurrent = selectedScope;

        if (this.twwSearchRequest) this.twwSearchRequest.abort();
        this.twwSearchRequest = new AbortController();

        var requestUrl = this.routesPredictiveSearchURL
          + '?q=' + encodeURIComponent(searchTerm)
          + '&section_id=predictive-search'
          + '&resources[type]=' + resourceTypes
          + '&resources[limit]=6'
          + '&resources[options][fields]=title,product_type,variants.sku,tag';

        fetch(requestUrl, { signal: this.twwSearchRequest.signal })
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (text) {
            var documentFragment = new DOMParser().parseFromString(text, 'text/html');
            var searchSection = documentFragment.querySelector('#shopify-section-predictive-search');

            if (!searchSection) throw new Error('Predictive search section was not returned.');

            this.predictiveSearchResults.innerHTML = searchSection.innerHTML;
            this.open();
          }.bind(this))
          .catch(function (error) {
            if (error.name === 'AbortError') return;
            this.close();
            console.error('Predictive search failed:', error);
          }.bind(this));
      };

      var originalOpen = PredictiveSearch.prototype.open;
      PredictiveSearch.prototype.open = function () {
        var formBounds = this.querySelector('.header-search-form').getBoundingClientRect();
        this.style.setProperty('--tww-search-panel-top', Math.round(formBounds.bottom + 8) + 'px');
        originalOpen.call(this);
        this.input.setAttribute('aria-expanded', 'true');
        document.body.classList.add('tww-search-open');
      };

      var originalClose = PredictiveSearch.prototype.close;
      PredictiveSearch.prototype.close = function () {
        originalClose.call(this);
        this.input.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('tww-search-open');
      };
    }

    document.querySelectorAll('predictive-search').forEach(function (search) {
      if (search.dataset.twwSearchReady === 'true') return;
      search.dataset.twwSearchReady = 'true';

      var input = search.querySelector('input[type="search"]');
      var clearButton = search.querySelector('.tww-search-clear');
      var scope = search.querySelector('[data-search-scope]');

      if (!input || !clearButton) return;

      function updateClearButton() {
        clearButton.hidden = input.value.length === 0;
      }

      updateClearButton();
      input.addEventListener('input', updateClearButton);

      clearButton.addEventListener('click', function () {
        input.value = '';
        updateClearButton();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });

      if (scope) {
        scope.addEventListener('change', function () {
          search.dataset.searchScopeCurrent = scope.value;
          if (input.value.trim()) search.getSearchResults(input.value.trim());
          input.focus();
        });
      }

      search.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        search.close();
        input.focus();
      });
    });

    document.addEventListener('pointerdown', function (event) {
      document.querySelectorAll('predictive-search').forEach(function (search) {
        if (!search.contains(event.target) && search.input && search.input.getAttribute('aria-expanded') === 'true') {
          search.close();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.customElements) return;
    customElements.whenDefined('predictive-search').then(initTwwSearch);
  });
})();
